module.exports = __webpack_public_path__ + "static/media/NoeDisplay-Regular.4efb44db.woff2";